import {
  usePennylaneCompanies,
  usePennylaneUsers,
} from "../../hooks/use-admin-pennylane";
import Card from "../UI/Card";
import Text from "../UI/Text";
import Title from "../UI/Title";
// @ts-expect-error pure js
import { handleAPIError } from "../../utils";

export default function AdminPennylane() {
  const {
    users,
    isLoading: usersLoading,
    error: usersError,
  } = usePennylaneUsers();
  const {
    companies,
    isLoading: companiesLoading,
    error: companiesError,
  } = usePennylaneCompanies();

  const error = usersError || companiesError;

  return (
    <Card>
      <Title variant="kilo" className="marginB20">
        Pennylane
      </Title>

      {error && (
        <Card type="error" className="padding10 marginB20">
          {handleAPIError(error)}
        </Card>
      )}

      <Title variant="kilo" className="marginB10">
        Utilisateurs ({usersLoading ? "..." : users.length})
      </Title>
      {users.length > 0 ? (
        <table className="table marginB20">
          <thead>
            <tr>
              <th>ID</th>
              <th>Email</th>
              <th>Nom</th>
              <th>Prénom</th>
              <th>Téléphone</th>
              <th>Créé le</th>
            </tr>
          </thead>
          <tbody>
            {users.map((user) => (
              <tr key={user.id}>
                <td>{user.id}</td>
                <td>{user.email}</td>
                <td>{user.last_name}</td>
                <td>{user.first_name}</td>
                <td>{user.phone_number}</td>
                <td>{new Date(user.created_at).toLocaleDateString("fr-FR")}</td>
              </tr>
            ))}
          </tbody>
        </table>
      ) : (
        <Text color="muted" className="marginB20">
          {usersLoading ? "Chargement..." : "Aucun utilisateur"}
        </Text>
      )}

      <Title variant="kilo" className="marginB10">
        Sociétés ({companiesLoading ? "..." : companies.length})
      </Title>
      {companies.length > 0 ? (
        <table className="table">
          <thead>
            <tr>
              <th>ID</th>
              <th>Nom</th>
              <th>SIRET</th>
              <th>Plan</th>
              <th>Adresse</th>
              <th>Créé le</th>
            </tr>
          </thead>
          <tbody>
            {companies.map((company) => (
              <tr key={company.id}>
                <td>{company.id}</td>
                <td>{company.name}</td>
                <td>{company.reg_no}</td>
                <td>{company.saas_plan}</td>
                <td>
                  {company.address}, {company.postal_code} {company.city}
                </td>
                <td>
                  {new Date(company.created_at).toLocaleDateString("fr-FR")}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      ) : (
        <Text color="muted">
          {companiesLoading ? "Chargement..." : "Aucune société"}
        </Text>
      )}
    </Card>
  );
}
